<script>
import Swiper from 'swiper';
export default {
    props: ['name', 'slidesPerView', 'loop'],
    data() {
        return {
            swiper: null,
        };
    },
    mounted() {
        this.swiper = new Swiper(`.swiper-slider-${this.name}`, {
            slidesPerView: 3,
            spaceBetween: 10,
            slidesPerGroup: 3,
            loop: this.loop,
            navigation: {
                nextEl: `.next-${this.name}`,
                prevEl: `.prev-${this.name}`
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                }
            },
        });
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/SwiperFeaturesNavigation.vue